/** Skill / enemy factions from gameplay_ideas. */
export const FACTIONS = ['human', 'god', 'demon'] as const;

export type Faction = (typeof FACTIONS)[number];
